import React, { useState } from "react";
import { Link, Link as RouterLink } from "react-router-dom";
import {
    IconButton,
    makeStyles,
    Typography
} from "@material-ui/core";
import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";
import Table from "@material-ui/core/Table";
import TableContainer
    from "@material-ui/core/TableContainer";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import Box from "@material-ui/core/Box";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import { Delete, Edit } from "@material-ui/icons";
import CancelIcon from "@material-ui/icons/Cancel";
import CheckCircleIcon
    from "@material-ui/icons/CheckCircle";
import RemoveCircleRoundedIcon
    from "@material-ui/icons/RemoveCircleRounded";
import styled from "styled-components";
import {
    usePagination,
    useRowSelect,
    useTable,
    useSortBy,
} from "react-table";
import apiHelper from "../../../util/ApiHelper";
import { CustomCheckbox, formatDatetime, modal } from "../../../util";
import { useLoading } from "../../../util/LoadingProvider";
import { toast } from "react-toastify";
import EventManageListing
    from "./components/EventManageListing";
import EventManageEdit
    from "./components/EventManageEdit";
import {
    PaginationHandler
} from "../../../util/useManualPagination";
import DragHandleIcon from "@material-ui/icons/DragHandle";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import TableSortLabel from "@material-ui/core/TableSortLabel";

const useStyles = makeStyles((theme) => ({
    tabpanel: {
        background: "#FFFFFF",
    },
    textInput: {
        backgroundColor: "white",
        width: "100%",
        marginBottom: "12px",

        "& input": {
            fontSize: "14px",
        },
    },
    content: {
        "& .ck-editor__editable_inline": {
            minHeight: "200px",
        },
    },
    buttonGroup: {
        marginTop: "20px",
        textAlign: "right",
        "& button": {
            color: "#306F9D",
            fontSize: "13px",
            textTransform: "inherit",
        },
    },
    box: {
        padding: 0,
        background: "#ffffff",
        paddingTop: "10px",
        paddingBottom: "10px",
        minHeight: "800px",
    },
    innerBox: {
        background: "#ffffff",
        padding: theme.spacing(3),
        marginBottom: theme.spacing(4),
    },
    button: {
        backgroundColor: "#306F9D",
        textTransform: "capitalize",
        color: "white",
        "&:hover": {
            backgroundColor: "#306F9D",
        },
    },
    pagination: {
        "& .MuiTextField-root": {
            width: "35px",
            minWidth: "auto",
        },
        "& .MuiSelect-root": {
            paddingTop: "3px",
            paddingBottom: "3px",
        },
        "& input": {
            padding: "4px 0",
            marginLeft: "10px",
            marginRight: "10px",
        },
        "& button": {
            background: "white",
            color: "#cccccc",
            border: "1px solid #CCCCCC",
            minWidth: "auto",
            width: "24px",
            height: "24px",
            margin: "4px 0",
            "&.left": {
                borderRadius: "4px 0 0 4px",
                marginLeft: "10px",
            },
            "&.right": {
                borderRadius: " 0 4px 4px 0",
            },
        },
    },
}));

/** DRAG N DROP PREPARATION STARTS **/

const IsDraggingContext = React.createContext(false);

const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    return result;
};

class DraggableTableCell extends React.Component {
    getSnapshotBeforeUpdate(prevProps) {
        if (!this.ref) {
            return null;
        }
        const isDragStarting =
            this.props.isDragOccurring && !prevProps.isDragOccurring;
        if (!isDragStarting) {
            return null;
        }
        const { width, height } = this.ref.getBoundingClientRect();
        const snapshot = {
            width,
            height,
        };
        return snapshot;
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        const ref = this.ref;
        if (!ref) {
            return;
        }
        if (snapshot) {
            if (ref.style.width === snapshot.width) {
                return;
            }
            ref.style.width = `${snapshot.width}px`;
            ref.style.height = `${snapshot.height}px`;
            return;
        }
        if (this.props.isDragOccurring) {
            return;
        }
        // inline styles not applied
        if (ref.style.width == null) {
            return;
        }
        // no snapshot and drag is finished - clear the inline styles
        ref.style.removeProperty("height");
        ref.style.removeProperty("width");
    }

    setRef = (ref) => {
        this.ref = ref;
    };

    render() {
        return (
            <TableCell
                style={{ paddingTop: 6, paddingBottom: 6 }}
                ref={this.setRef}
                align={this.props.align}
            >
                {this.props.children}
            </TableCell>
        );
    }
}

const DraggableTableRow = ({ snapshot, data, row, provided, className }) => {
    return (
        <IsDraggingContext.Consumer>
            {(isDragging) => (
                <TableRow
                    className={className}
                    ref={provided.innerRef}
                    isDragging={snapshot.isDragging}
                    {...provided.draggableProps}
                >
                    {row.cells.map((cell) => {
                        if (cell.column.id !== "dragHandle") {
                            return (
                                <DraggableTableCell isDragOccurring={isDragging} scope="row">
                                    {cell.render("Cell")}
                                </DraggableTableCell>
                            );
                        } else {
                            return null;
                        }
                    })}
                    <TableCell
                        style={{ paddingTop: 6, paddingBottom: 6, color: "#CCCCCC" }}
                        {...provided.dragHandleProps}
                    >
                        <DragHandleIcon />
                    </TableCell>
                </TableRow>
            )}
        </IsDraggingContext.Consumer>
    );
};

/** DRAG N DROP PREPARATION ENDS **/

const statuses = {
    1: "active",
    2: "inactive",
};

const IndeterminateCheckbox = React.forwardRef(
    ({ indeterminate, ...rest }, ref) => {
        const defaultRef = React.useRef();
        const resolvedRef = ref || defaultRef;

        React.useEffect(() => {
            resolvedRef.current.indeterminate = indeterminate;
        }, [resolvedRef, indeterminate]);

        return <CustomCheckbox type="checkbox"
            ref={resolvedRef} {...rest} />;
    }
);

function getKeyword(keyword) {
    return keyword ? `&keyword=${keyword}` : "";
}

const StatusFilter = styled.ul`
  list-style: none;
  display: inline-flex;
  padding: 0;
  margin-left: 25px;

  li {
    button {
      border: 0px;
      background: transparent;
      color: #306f9d;
      font-size: 13px;
      line-height: 15px;
      padding: 0 10px;
      cursor: pointer;

      &.active {
        font-weight: bold;
        color: #333333;
      }
    }

    &:not(:last-of-type) {
      button {
        border-right: 1px solid black;
      }
    }

    &:first-of-type {
      button {
        padding-left: 0;
      }
    }
  }
`;

function TabPanel(props) {
    const classes = useStyles();
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`nav-tabpanel-${index}`}
            aria-labelledby={`nav-tab-${index}`}
            {...other}
        >
            <Box p={3} className={classes.box}>
                {children}
            </Box>
        </div>
    );
}

function a11yProps(index) {
    return {
        id: `nav-tab-${index}`,
        "aria-controls": `nav-tabpanel-${index}`,
    };
}

function EventCategoryListingPage(props) {
    const { match, path } = props;
    const classes = useStyles();
    const [disabled, setDisabled] = React.useState(props.disabled);
    const [activeTab, setActiveTab] = React.useState(0);
    const [actionType, setActionType] = React.useState("");
    const [editEventManage, setEditEventManage] = React.useState(false);
    const [keyword, setKeyword] = React.useState("");
    const [queryString, setQueryString] = React.useState("");
    const [data, setData] = React.useState([]);
    const [totalPages, setTotalPages] = React.useState(1);
    const [status, setStatus] = React.useState(null);
    const [paginationHandler] = React.useState(new PaginationHandler());
    const { setLoading } = useLoading();

    // for pagination
    const [elementCounts, setElementCounts] = React.useState({
        all: 0,
        active: 0,
        inactive: 0,
    });

    // for Drag & Drop
    const [orderingDisabled, setOrderingDisabled] = useState(false);
    const [isDragging, setIsDragging] = useState(false);
    const onBeforeDragStart = () => {
        setIsDragging(true);
    };
    const onDragEnd = (result) => {
        //callback passed to dragdrop context
        // dropped outside the list
        if (!result.destination) {
            return;
        }
        const items = reorder(data, result.source.index, result.destination.index);
        console.log("ON DRAG END:", items);
        setData(items);
    };

    const CustomLink = React.useMemo(
        () =>
            React.forwardRef((linkProps, ref) => <Link
                ref={ref} {...linkProps} />),
        []
    );

    const handleSelectChange = (e) => {
        setActionType(e.target.value);
    };


    const columns = React.useMemo(
        () => [
            {
                Header: "Name",
                accessor: "nameEn",
            },
            {
                Header: "Status",
                accessor: "status",
                Cell: ({ row }) => {
                    return (
                        <>{row.original.status === true ? "Active" : "Inactive"}</>
                    );
                },
            },
            {
                Header: "Last Update",
                accessor: "updateTime",
                disableGlobalFilter: true,
                Cell: ({ row }) => {
                    return formatDatetime(row.original.updateTime);
                },
            },
        ],
        [disabled]
    );

    const {
        getTableProps,
        headerGroups,
        rows,
        prepareRow,
        setPageSize,
        gotoPage,
        previousPage,
        nextPage,
        canPreviousPage,
        canNextPage,
        selectedFlatRows,
        state: { pageIndex, pageSize },
    } = useTable(
        {
            columns,
            data,
            initialState: { pageIndex: 0, pageSize: 10 },
            manualPagination: true,
            pageCount: totalPages,
        },
        useSortBy,
        usePagination,
        useRowSelect,
        (hooks) => {
            hooks.visibleColumns.push((columns) => [
                // Let's make a column for selection
                {
                    id: "selection",
                    // The header can use the table's getToggleAllRowsSelectedProps method
                    // to render a checkbox
                    Header: ({ getToggleAllRowsSelectedProps }) => (
                        <div>
                            <IndeterminateCheckbox {...getToggleAllRowsSelectedProps()} />
                        </div>
                    ),
                    // The cell can use the individual row's getToggleRowSelectedProps method
                    // to the render a checkbox
                    Cell: ({ row }) => (
                        <div>
                            <IndeterminateCheckbox {...row.getToggleRowSelectedProps()} />
                        </div>
                    ),
                },
                ...columns,
                {
                    id: "action",
                    // The header can use the table's getToggleAllRowsSelectedProps method
                    // to render a checkbox
                    Header: () => <div>Action</div>,
                    // The cell can use the individual row's getToggleRowSelectedProps method
                    // to the render a checkbox
                    Cell: ({ row }) => (
                        <div
                            style={{ display: "inline-flex" }}>
                            <IconButton
                                className={classes.iconBtn}
                                size="small"
                                component={CustomLink}
                                to={`${match.url}/category/${row.original.id}`}
                            >
                                <Edit fontSize="small" />
                            </IconButton>
                            {disabled || (
                                <IconButton
                                    className={classes.iconBtn}
                                    size="small"
                                    onClick={() => {
                                        deleteEventCategory(row.original.id);
                                    }}
                                >
                                    <Delete
                                        fontSize="inherit" />
                                </IconButton>
                            )}
                        </div>
                    ),
                },
                // The drag handle can be used to drag the table's rows individually
                {
                    id: "dragHandle",
                    Header: () => <></>,
                },
            ]);
        }
    );

    const handleChange = (event, newValue) => {
        setActiveTab(newValue);
        if (newValue === 1) {
            window.history.replaceState(
                null,
                "Event Category",
                "/hkiff/event/category"
            );
        } else {
            window.history.replaceState(
                null,
                "Event Manage",
                "/hkiff/event"
            );
        }
    };

    const getEventCategory = React.useCallback(async () => {
        try {
            console.log("getting getEventCategory/////////////");
            setLoading(true);
            const result = await apiHelper.hkiff.getEventCategories(
                "en",
                0,
                0,
                999999
            );
            console.log(result);
            paginationHandler.setPageIndex(0).setRows(result.data.content);
            const content = paginationHandler.filterRowsByAll().getRows();
            const newTotalPages = paginationHandler.getTotalPages();

            const all = paginationHandler.getTotalRows();
            const active = paginationHandler.getStatuslessRows()
                .filter((x) => x && x.status === true).length;
            const inactive = paginationHandler.getStatuslessRows()
                .filter((x) => x && x.status === false).length;

            setElementCounts({
                all,
                active,
                inactive,
            });

            setData(content.filter((x) => x));
            setTotalPages(newTotalPages);
        } catch (err) {
            console.log(err);
        } finally {
            setLoading(false);
        }
    }, [paginationHandler, setLoading]);


    const getMaxSeqInRows = (rows) => {
        let sequence = null;
        rows.forEach((e) => {
          if (
            (e.sequence && sequence === null) ||
            (sequence !== null && e.sequence > sequence)
          ) {
            sequence = e.sequence;
          }
        });
        return sequence;
      };
    
      const saveOrdering = async () => {
        try {
          const maxSeq = getMaxSeqInRows(data);
          const seqData = {};
          data.forEach((e, i) => {
            seqData[e.id] = maxSeq - i;
          });
          const result = await apiHelper.hkiff.orderEventCategories(seqData);
          if (result.data.code === 0) {
            toast.dark("Your changes is saved.");
            await getEventCategory();
          }
        } catch (err) {
          console.log(err);
        }
      };

    // disable ordering if used status filter or search
    React.useEffect(() => {
        if (keyword || status) {
            setOrderingDisabled(true);
        } else {
            setOrderingDisabled(false);
        }
    }, [keyword, status]);

    React.useEffect(() => {
        if (match.url.startsWith("/hkiff/event/category")) {
            setActiveTab(1);
        }
        if (
            match.url.match(/^\/hkiff\/event\/([^/])+$/)
        ) {
            setEditEventManage(true);
        } else {
            setEditEventManage(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    React.useEffect(() => {
        if (paginationHandler) getEventCategory(); // only get when paginationHandler ready
    }, [getEventCategory, paginationHandler]);

    const statusFilterHandler = (targetStatus) => () => {
        setLoading(true);
        setStatus(targetStatus);
        let target;
        if (targetStatus === statuses[1]) {
            target = true;
        } else if (targetStatus === statuses[2]) {
            target = false;
        } else {
            target = null;
        }
        paginationHandler
            .resetRows()
            .setQueryStatus("status", target)
            .filterRowsByAll();
        console.log(paginationHandler.getRows());
        setData(paginationHandler.getRows());
        gotoPage(0);
        setLoading(false);
    };

    const triggerSearch = React.useCallback(() => {
        setLoading(true);
        setQueryString(keyword);
        paginationHandler
            .resetRows()
            .setQueryString("nameEn", keyword)
            .filterRowsByAll();
        const newTotalPages = paginationHandler.getTotalPages();
        setTotalPages(newTotalPages);
        gotoPage(0);
        setData(paginationHandler.setPageIndex(0).getRows());
        const all = paginationHandler.getStatuslessRows().length;
        const active = paginationHandler
            .getStatuslessRows()
            .filter((x) => x.status == true).length;
        const inactive = paginationHandler
            .getStatuslessRows()
            .filter((x) => x.status == false).length;
        setElementCounts({
            all,
            active,
            inactive,
        });
        setLoading(false);
    }, [gotoPage, keyword, paginationHandler, setLoading]);

    const deleteEventCategory = React.useCallback(async (id) => {
        const decision = await modal.fire({
            title: "Delete Event Category",
            text: "Are you sure to delete this Event Category?",
            showCancelButton: true,
            confirmButtonText: `Delete`,
        });
        if (decision.isConfirmed) {
            try {
                const result = await apiHelper.hkiff.deleteEventCategoryById(id);
                if (result.data.code === 0) {
                    toast.dark("Event Category deleted.");
                }
                await getEventCategory();
            } catch (err) {
                console.log(err);
            }
        }
    }, [rows, actionType, getEventCategory]);

    const handleBulkAction = React.useCallback(async () => {
        switch (actionType) {
            case "DELETE":
                const ids = selectedFlatRows.map((o) => o.original.id);
                if (ids.length > 0) {
                    const decision = await modal.fire({
                        title: "Delete Event Category",
                        text: `Are you sure to delete ${ids.length} Event Category(s)?`,
                        showCancelButton: true,
                        confirmButtonText: `Delete`,
                    });
                    if (decision.isConfirmed) {
                        try {
                            const promises = ids.map((id) =>
                                apiHelper.hkiff.deleteEventCategoryById(id)
                            );
                            await Promise.all(promises);
                            toast.dark(`${ids.length} Event Category(s) deleted.`);
                            await getEventCategory();
                        } catch (err) {
                            console.log(err);
                        }
                    }
                }
                break;
            default:
                break;
        }
    }, [rows, actionType, getEventCategory]);

    React.useEffect(() => {
        console.log('elementCounts', elementCounts);
    }, [elementCounts])

    return (
        <div className={classes.content}>
            <Typography variant="h4" gutterBottom>
                Event
            </Typography>
            <Tabs
                value={activeTab}
                onChange={handleChange}
                aria-label="nav tabs example"
                TabIndicatorProps={{
                    style: {
                        top: "0",
                        background: "#306F9D"
                    }
                }}
            >
                <Tab label="Manage" {...a11yProps(0)} />
                <Tab
                    label="Category" {...a11yProps(1)} />
            </Tabs>
            <form>
                <TabPanel value={activeTab} index={0}>
                    {/* {editEventManage ? (
                        <EventManageEdit
                            getTemplateApi={apiHelper.hkiff.getEventCategoryTemplates}
                            onSubmitApi={apiHelper.hkiff.saveEventCategoryTemplate}
                            setLoading={setLoading}
                            match={match}
                            setDisabled={setDisabled}
                        />
                    ) : (
                        <EventManageListing
                            classes={classes}
                            setLoading={setLoading}
                            CustomLink={CustomLink}
                            IndeterminateCheckbox={IndeterminateCheckbox}
                            match={match}
                            disabled={disabled}
                            getTemplateApi={apiHelper.hkiff.getEventCategoryTemplates}
                        />
                    )} */}
                </TabPanel>
                <TabPanel value={activeTab} index={1}>
                    <StatusFilter>
                        <li>
                            <button
                                className={status === null ? "active" : ""}
                                type="button"
                                onClick={statusFilterHandler(null)}
                            >
                                <Typography variant="p">All
                                    ({elementCounts.all})</Typography>
                            </button>
                        </li>
                        <li>
                            <button
                                className={status === "active" ? "active" : ""}
                                type="button"
                                onClick={statusFilterHandler(statuses[1])}
                            >
                                <Typography variant="p">
                                    Active
                                    ({elementCounts.active})
                                </Typography>
                            </button>
                        </li>
                        <li>
                            <button
                                className={status === "inactive" ? "active" : ""}
                                type="button"
                                onClick={statusFilterHandler(statuses[2])}
                            >
                                <Typography variant="p">
                                    Inactive
                                    ({elementCounts.inactive})
                                </Typography>
                            </button>
                        </li>
                    </StatusFilter>
                    <Grid
                        container
                        justify="space-between"
                        style={{ padding: "0 25px 10px" }}
                    >
                        <Grid container item xs={3} md={3}>
                            <Box width="100%"
                                component="span"
                                display="flex">
                                <Box width="100%">
                                    <FormControl fullWidth
                                        margin="dense"
                                        variant="outlined">
                                        <InputLabel
                                            id="demo-simple-select-outlined-label">
                                            Bulk Actions
                                        </InputLabel>
                                        <Select
                                            labelId="demo-simple-select-outlined-label"
                                            id="demo-simple-select-outlined"
                                            value={actionType}
                                            onChange={handleSelectChange}
                                            label="Bulk Actions"
                                        >
                                            <MenuItem
                                                value="">
                                                <em>None</em>
                                            </MenuItem>
                                            <MenuItem
                                                value={"DELETE"}>Delete</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Box>
                                <Box display="flex">
                                    <Button
                                        variant="outlined"
                                        color="primary"
                                        onClick={handleBulkAction}
                                        disabled={disabled}
                                    >
                                        Apply
                                    </Button>
                                </Box>
                            </Box>
                        </Grid>
                        <Grid container item xs={12} md={8}>
                            <Box
                                width="100%"
                                component="span"
                                display="flex"
                                justifyContent="flex-end"
                                alignItems="center"
                            >
                                <Box display="flex">
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        type="button"
                                        component={RouterLink}
                                        to={`${match.url}/category/new`}
                                    >
                                        Add New Category
                                    </Button>
                                </Box>
                                <Box display="flex">
                                    <TextField
                                        id="outlined-error"
                                        label="Search"
                                        variant="outlined"
                                        margin="dense"
                                        value={keyword}
                                        onChange={(e) => setKeyword(e.target.value)}
                                    />
                                </Box>
                                <Box display="flex">
                                    <Button
                                        variant="outlined"
                                        color="primary"
                                        type="button"
                                        margin="dense"
                                        onClick={triggerSearch}
                                    >
                                        Search
                                    </Button>
                                </Box>
                            </Box>
                        </Grid>
                    </Grid>
                    <Grid container xs={12}>
                        <IsDraggingContext.Provider value={isDragging}>
                            <TableContainer
                                component={Paper}
                                style={{
                                    margin: "0 25px",
                                    boxShadow: "none",
                                    border: "1px solid #cccccc",
                                }}
                            >
                                <fieldset disabled={disabled}
                                    className="fieldset">
                                    <Table
                                        aria-label="simple table"
                                        component="ul"
                                        style={{ margin: "0" }}
                                        {...getTableProps()}
                                    >
                                        <TableHead
                                            component="div">
                                            {headerGroups.map((headerGroup) => (
                                                <TableRow {...headerGroup.getHeaderGroupProps()}>
                                                    {headerGroup.headers.map((column) => (
                                                        <TableCell
                                                            {...column.getHeaderProps(
                                                                column.getSortByToggleProps()
                                                            )}
                                                            className={`${column.className ?? ""}`}
                                                            style={{
                                                                paddingTop: 6,
                                                                paddingBottom: 6,
                                                                lineHeight: "1.1em",
                                                                height: "48px",
                                                            }}
                                                        >
                                                            <span
                                                                className={
                                                                    column.disableSortBy !== true
                                                                        ? classes.sortableHeader
                                                                        : ``
                                                                }
                                                            >
                                                                {column.render("Header")}
                                                            </span>
                                                            {column.id !== "selection" &&
                                                                column.id !== "dragHandle" &&
                                                                column.disableSortBy !== true ? (
                                                                    <TableSortLabel
                                                                        active={column.isSorted}
                                                                        // react-table has an unsorted state which is not treated here
                                                                        direction={column.isSortedDesc ? "desc" : "asc"}
                                                                    />
                                                                ) : null}
                                                        </TableCell>
                                                    ))}
                                                </TableRow>
                                            ))}
                                        </TableHead>
                                        <DragDropContext
                                            onBeforeDragStart={onBeforeDragStart}
                                            onDragEnd={onDragEnd}
                                        >
                                            <Droppable droppableId="droppable">
                                                {(provided, snapshot) => (
                                                    <TableBody
                                                        ref={provided.innerRef}
                                                        {...provided.droppableProps}
                                                    >
                                                        {rows.map((row, index) => {
                                                            prepareRow(row);
                                                            return (
                                                                <Draggable
                                                                    key={row.id}
                                                                    draggableId={row.id}
                                                                    index={index}
                                                                    isDragDisabled={disabled || orderingDisabled}
                                                                >
                                                                    {(provided, snapshot) => (
                                                                        <DraggableTableRow
                                                                            key={row.id}
                                                                            data={row.original}
                                                                            row={row}
                                                                            provided={provided}
                                                                            snapshot={snapshot}
                                                                        />
                                                                    )}
                                                                </Draggable>
                                                            );
                                                        })}
                                                    </TableBody>
                                                )}
                                            </Droppable>
                                        </DragDropContext>
                                    </Table>
                                </fieldset>
                            </TableContainer>
                        </IsDraggingContext.Provider>
                    </Grid>
                    <Grid container xs={12} style={{ padding: "5px 25px 10px" }}>
                        <Grid container item xs={4}>
                            <Box display="flex">
                                <Button
                                    variant="contained"
                                    color="primary"
                                    type="button"
                                    disabled={disabled || orderingDisabled}
                                    onClick={saveOrdering}
                                >
                                    Save Changes
                                </Button>
                            </Box>
                        </Grid>
                        <Grid
                            container
                            item
                            xs={8}
                            justify="flex-end"
                            style={{
                                paddingRight: "25px",
                                marginTop: "15px",
                            }}
                        >
                            <div className={classes.flexRow}>
                                <div></div>
                                <div
                                    className={classes.pagination}>
                                    Show rows:{" "}
                                    <TextField
                                        id="page-rows"
                                        select
                                        value={pageSize}
                                        onChange={(e) => {
                                            setPageSize(Number(e.target.value));
                                            setData(
                                                paginationHandler
                                                    .setPageSize(Number(e.target.value))
                                                    .getRows()
                                            );
                                            setTotalPages(paginationHandler.getTotalPages());
                                        }}
                                        variant="outlined"
                                        style={{ minWidth: "70px" }}
                                    >
                                        {[5, 10, 25].map((pageSize) => (
                                            <MenuItem
                                                key={pageSize}
                                                value={pageSize}>
                                                {pageSize}
                                            </MenuItem>
                                        ))}
                                    </TextField>
                                Go to{" "}
                                    <TextField
                                        id="pagination-field"
                                        variant="outlined"
                                        onChange={(e) => {
                                            const page = e.target.value
                                                ? Number(e.target.value) - 1
                                                : 0;
                                            gotoPage(page);
                                            setData(paginationHandler.setPageIndex(page).getRows());
                                        }}
                                    />
                                    {pageIndex * pageSize + 1} to{" "}
                                    {(pageIndex + 1) * pageSize >
                                        elementCounts[status || "all"]
                                        ? elementCounts[status || "all"]
                                        : (pageIndex + 1) * pageSize}{" "}
                                of {elementCounts[status || "all"]}
                                    <Button
                                        onClick={() => {
                                            previousPage();
                                            setData(
                                                paginationHandler.setPageIndex(pageIndex - 1).getRows()
                                            );
                                        }}
                                        disabled={!canPreviousPage}
                                        className="left"
                                    >
                                        {"<"}
                                    </Button>
                                    <Button
                                        onClick={() => {
                                            nextPage();
                                            setData(
                                                paginationHandler.setPageIndex(pageIndex + 1).getRows()
                                            );
                                        }}
                                        disabled={!canNextPage}
                                        className="right"
                                    >
                                        {">"}
                                    </Button>
                                </div>
                            </div>
                        </Grid>
                    </Grid>
                </TabPanel>
            </form>
        </div>
    );
}

export default EventCategoryListingPage;
